import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { postAddressSearchPage } from "services/post-addressSearchPage";
import { overlayState, customerInfoCaptureModalState } from "atoms";
import { useSetRecoilState } from "recoil";
import CustomerCaptureInfo from "./CustomerCaptureInfo";

const AddressSearchModal: React.FC<{
  setShowAddressModal: Function;
  showAddressModal: boolean;
  locationId: number;
}> = ({ setShowAddressModal, showAddressModal, locationId }) => {
  const setCustomerInfoCaptureModal = useSetRecoilState(customerInfoCaptureModalState);
  const setShowOverlay = useSetRecoilState(overlayState);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [params, setParams] = useState<any>({
    specialOfferItem: "",
    specialOfferType: "",
    specialOfferCoreType: "",
    utm_content: "",
    utm_medium: "",
    utm_source: "",
    utm_campaign: "",
  });

  useEffect(() => {
    const fetchUrlParams = () => {
      const specialOfferItem = searchParams.get("item");
      const specialOfferType = searchParams.get("type");
      const specialOfferCoreType = searchParams.get("coretype");
      const utm_content = searchParams.get("utm_content");
      const utm_medium = searchParams.get("utm_medium");
      const utm_source = searchParams.get("utm_source");
      const utm_campaign = searchParams.get("utm_campaign");
      setParams({
        ...params,
        specialOfferItem: specialOfferItem,
        specialOfferType: specialOfferType,
        specialOfferCoreType: specialOfferCoreType,
        utm_content: utm_content,
        utm_medium: utm_medium,
        utm_source: utm_source,
        utm_campaign: utm_campaign,
      });
    };
    fetchUrlParams();
    // eslint-disable-next-line
  }, [searchParams]);

  const handleService = async (movingExistingService: boolean) => {
    setShowOverlay(true);
    setShowAddressModal(false);
    const response: any = await postAddressSearchPage(
      locationId,
      movingExistingService,
      params.specialOfferItem,
      params.specialOfferType,
      params.specialOfferCoreType,
      params.specialOfferItem?.utm_content,
      params.specialOfferItem?.utm_medium,
      params.specialOfferItem?.utm_source,
      params.specialOfferItem?.utm_campaign
    );

    const redirectUrl = response?.["_links"]?.["ec:windowLocation"]?.href;
    // Will look for leadInfoPage in the response to display the Lead Capture Form
    if (redirectUrl?.includes("leadInfoPage")) {
      setCustomerInfoCaptureModal(true);
      return;
    } else {
      const { _links: links = {} } = response;
      const windowLocationHref = links["ec:windowLocation"]?.href;

      if (windowLocationHref) {
        if (movingExistingService) {
          window.location.href = windowLocationHref;
        } else {
          navigate(windowLocationHref);
        }
      }
    }

    setShowOverlay(false);
  };

  return (
    <>
      <Modal
        show={showAddressModal}
        onHide={() => setShowAddressModal(false)}
        className="address-serch-modal"
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            A Comporium account already exists at this address.{" "}
            <span className="account-yours">
              <strong>Is this account yours?</strong>
            </span>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-grid gap-2 d-flex">
            <button className="btn btn-primary w-100 live-here" onClick={() => handleService(true)}>
              Yes, I live here.
            </button>
            <button
              className="btn btn-primary w-100 move-here"
              onClick={() => {
                handleService(false);
              }}
            >
              No, I'm moving here.
            </button>
          </div>
        </Modal.Body>
      </Modal>
      <CustomerCaptureInfo
        item={params.specialOfferItem}
        type={params.specialOfferType}
        coreType={params.specialOfferCoreType}
        utmContent={params.utm_content}
        utmMedium={params.utm_medium}
        utmSource={params.utm_source}
        utmCampaign={params.utm_campaign}
      />
    </>
  );
};

export default AddressSearchModal;
